(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = document.documentElement.classList.contains('shopify-design-mode');
  var main = document.querySelector('main');
  if (!main) return;

  var firstSection = main.querySelector(':scope > .shopify-section');
  var hero = firstSection && firstSection.querySelector('.hero');

  /* ---- Sticky frosted buy bar: show once the hero has scrolled away ---- */
  var sticky = document.querySelector('[data-sh-sticky]');
  if (sticky) sticky.removeAttribute('hidden');

  /* ---- Scroll-linked hero: content eases back and fades, background drifts ---- */
  var content = hero && hero.querySelector('.hero__content-wrapper');
  var media = hero && hero.querySelector('.hero__media-grid');
  var ticking = false;

  function onScroll() {
    ticking = false;
    var y = window.scrollY || window.pageYOffset;
    var h = hero ? hero.offsetHeight : 600;

    if (sticky) sticky.classList.toggle('is-visible', y > h * 0.75);

    if (reduce || designMode || !hero) return;
    var p = Math.min(Math.max(y / h, 0), 1);
    if (content) {
      content.style.transform = 'translate3d(0,' + (p * 70).toFixed(1) + 'px,0) scale(' + (1 - p * 0.07).toFixed(4) + ')';
      content.style.opacity = (1 - p * 1.1).toFixed(3);
    }
    if (media) media.style.transform = 'translate3d(0,' + (p * 140).toFixed(1) + 'px,0)';
  }
  function requestTick() { if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); } }

  if (hero) hero.classList.add('sh-hero');
  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick);
  onScroll();

  /* ---- Blur-to-sharp reveals with staggered children ---- */
  if (reduce || designMode || !('IntersectionObserver' in window)) return;

  var sections = main.querySelectorAll(':scope > .shopify-section:not(:first-child)');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var target = entry.target;
        target.classList.add('sh-in');
        io.unobserve(target);
        /* Hand control back to hover effects once the reveal has finished */
        window.setTimeout(function () {
          target.querySelectorAll('.sh-item').forEach(function (el) {
            el.classList.remove('sh-item');
            el.style.removeProperty('--sh-i');
          });
        }, 380 + 8 * 60 + 80);
      }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.06 });

  sections.forEach(function (section) {
    if (section.querySelector('.sh-sticky')) return;
    var items = section.querySelectorAll('.hero__content-wrapper > *, product-card');
    if (!items.length) items = [section];
    var seen = [];
    Array.prototype.forEach.call(items, function (el) {
      if (seen.indexOf(el) !== -1) return;
      seen.push(el);
      el.classList.add('sh-item');
      el.style.setProperty('--sh-i', Math.min(seen.length - 1, 8));
    });
    section.classList.add('sh-reveal');
    io.observe(section);
  });

})();
